export default __webpack_public_path__ + "static/media/PuntoMetaVacio.7e7d2b26.png";